/* The run-plane URL of an app in the 3D runtime (Execute deployment).
   Both org and app travel in the path — the engine resolves the tenant from
   the URL, so nothing is pinned in the engine's config and one engine serves
   every org's apps. The engine is mounted under the /api/v1/3dapp base
   path; REACT_APP_BEX3D_URL is the engine ORIGIN (a value that already
   carries the base path is tolerated). The per-org default app is
   `<orgId>/common`. */
export function openAppUrl(orgId: string, appId: string): string {
    const raw = process.env.REACT_APP_BEX3D_URL || 'http://localhost:8080';
    let origin = raw.trim().replace(/\/+$/, '').replace(/\/api\/v1\/3dapp$/, '');
    // Tolerate a scheme-less env value (e.g. "dev-bex.coolriots.ai"): without a
    // scheme the <a href> is treated as RELATIVE and resolves against the
    // current studio page, opening a broken in-app URL instead of the engine.
    // Force an absolute origin (http for localhost, https otherwise).
    if (origin && !/^[a-z][a-z0-9+.-]*:\/\//i.test(origin) && !origin.startsWith('//')) {
        origin = (origin.startsWith('localhost') || origin.startsWith('127.0.0.1')
            ? 'http://' : 'https://') + origin;
    }
    return `${origin}/api/v1/3dapp/engine/${encodeURIComponent(orgId)}/${encodeURIComponent(appId)}`;
}
